import { render, staticRenderFns } from "./AppointmentTreatSummary.vue?vue&type=template&id=585b86ce&scoped=true"
import script from "./AppointmentTreatSummary.vue?vue&type=script&lang=js"
export * from "./AppointmentTreatSummary.vue?vue&type=script&lang=js"
import style0 from "./AppointmentTreatSummary.vue?vue&type=style&index=0&id=585b86ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585b86ce",
  null
  
)

export default component.exports